'use strict';

angular.module('portal.react', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            //On some exams and education pages, login is not required

            //Default route for exams pages, with permission checks
            .state('portal.menus.exams', {
                url: '/exams{path:(?:/.*)|$}',
                templateUrl: paths.app + 'react/components/exams/exams.html',
                controller: 'PortalExams',
                params: {
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        $rootScope.$state.current.data.loginRequired = false;

                        var address = "exams" + $stateParams.path;
                        var splitAddress = address.split('/');
                        if (splitAddress.length > 2) {
                            address = '';
                            var edit = false;
                            var regex = /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;
                            if (regex.test(splitAddress[splitAddress.length - 1]) && splitAddress[splitAddress.length - 2] === "edit") {
                                edit = true;
                            }
                            for (var i = 0; i < splitAddress.length; i++) {
                                if (regex.test(splitAddress[i]) || (edit === false && splitAddress[i] === 'edit')) { continue; }
                                address += splitAddress[i] + ((i === splitAddress.length - 1 || ((edit === true && splitAddress[i] === 'edit'))) ? '' : '/');
                            }
                        }

                        return PortalPermissions.viewByAddress(address).then(function (accessObject) {
                            //No access
                            if (accessObject && !accessObject.access) {
                                $state.go('portal.menus.denied');
                            }
                            //Login required (will be used in api intercepter)
                            else if (accessObject && accessObject.requiredLogin) {
                                $rootScope.$state.current.data.loginRequired = true;
                            }
                            else if (!accessObject && ($stateParams.path.startsWith("/manage/sessions/") || $stateParams.path.startsWith("/sessions/"))) {
                                //Manage exams tabs, require login
                                $rootScope.$state.current.data.loginRequired = true;
                            }
                        });
                    }]
                }
            })

            //Default route for education pages, with permission checks
            .state('portal.menus.education', {
                url: '/education{path:(?:/.*)|$}',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation',
                params: {
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        $rootScope.$state.current.data.loginRequired = false;
                        var address = "education" + $stateParams.path;
                        if (address.startsWith("education/user/")) {
                            address = "service/personnel/report"; //Service Personnel Education Report
                        }
                        return PortalPermissions.viewByAddress(address).then(function (accessObject) {
                            //No access
                            if (accessObject && !accessObject.access) {
                                $state.go('portal.menus.denied');
                            }
                            //Login required (will be used in api intercepter)
                            else if (accessObject && accessObject.requiredLogin) {
                                $rootScope.$state.current.data.loginRequired = true;
                            }
                            else if (!accessObject && address.startsWith("education/courses/")) {
                                //Manage courses tabs, which are managed by course type instead of portal_pages, but require login
                                $rootScope.$state.current.data.loginRequired = true;
                            }
                        });
                    }]
                }
            })

            //Default route for account pages, with permission checks
            .state('portal.menus.myAccount', {
                url: '/account{path:(?:/.*)|$}',
                templateUrl: paths.app + 'react/components/myAccount/myAccount.html',
                controller: 'PortalMyAccount',
                params: {
                    loginRequired: true
                },
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.viewByAddress("account" + $stateParams.path).then(function (accessObject) {
                            //No access
                            if (accessObject && !accessObject.access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })

            .state('portal.menus.manage', {
                url: '/exams/manage/sessions',
                templateUrl: paths.app + 'react/components/exams/exams.html'
            })
            .state('portal.menus.examsManageSessions', {
                url: '/exams/manage/sessions',
                templateUrl: paths.app + 'react/components/exams/exams.html'
            })
            .state('portal.menus.examsExaminerSessions', {
                url: '/exams/sessions',
                templateUrl: paths.app + 'react/components/exams/exams.html'
            })
            .state('portal.menus.examsMySessions', {
                url: '/exams/mysessions',
                templateUrl: paths.app + 'react/components/exams/exams.html'
            })

            .state('portal.menus.userLookupEducationReport', {
                url: '/education/lookup/user/educationReport/:id',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.userLookupEducationCourseList', {
                url: '/education/lookup/user/courseList/:id',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })

            .state('portal.menus.educationServiceReport', {
                url: '/education/user/:userId',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationServiceCourseList', {
                url: '/education/user/:userId/courseList',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationMyReport', {
                url: '/education/myreports',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationFindCourses', {
                url: '/education/findcourses',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationMyCourses', {
                url: '/education/mycourses',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationManageCourses', {
                url: '/education/manage/courses',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationManageCoursesNew', {
                url: '/education/manage/courses/:statusId',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationManageCoursesUpcoming', {
                url: '/education/manage/courses/upcoming',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.educationManageCoursesTests', {
                url: '/education/manage/courses/tests',
                templateUrl: paths.app + 'react/components/education/education.html',
                controller: 'PortalEducation'
            })
            .state('portal.menus.accountDashboard', {
                url: '/account/dashboard',
                templateUrl: paths.app + 'react/components/myAccount/myAccount.html',
                controller: 'PortalMyAccount'
            })
            .state('portal.menus.accountCertifications', {
                url: '/account/certifications',
                templateUrl: paths.app + 'react/components/myAccount/myAccount.html',
                controller: 'PortalMyAccount'
            })
            .state('portal.menus.accountProfileNew', {
                url: '/account/profile',
                templateUrl: paths.app + 'react/components/myAccount/myAccount.html',
                controller: 'PortalMyAccount'
            })
            .state('portal.menus.accountContactProfiles', {
                url: '/account/contact_profiles',
                templateUrl: paths.app + 'react/components/myAccount/myAccount.html',
                controller: 'PortalMyAccount'
            })
            .state('portal.menus.accountDocumentNew', {
                url: '/account/documents',
                templateUrl: paths.app + 'react/components/myAccount/myAccount.html',
                controller: 'PortalMyAccount'
            })
            .state('portal.menus.investigations', {
                url: '/complaints/publicform',
                templateUrl: paths.app + 'react/components/investigations/investigationsForm.html',
                controller: 'PortalInvestigationForm',
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('portal.menus.complaintReceived', {
                url: '/complaints/received',
                templateUrl: paths.app + 'react/components/investigations/investigationsForm.html',
                controller: 'PortalInvestigationForm',
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view('portal.menus.investigations').then(function (access) {
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })

            .state('portal.menus.signatureCapture', {
                url: '/signature_capture/:id',
                templateUrl: paths.app + 'react/components/investigations/investigationsForm.html',
                controller: 'PortalInvestigationForm',
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            //No access
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })

            .state('portal.menus.signatureCaptureResponse', {
                url: '/signature_capture_response/:id',
                templateUrl: paths.app + 'react/components/investigations/investigationsForm.html',
                controller: 'PortalInvestigationForm',
                resolve: {
                    permission: ['$state', '$stateParams', '$rootScope', 'PortalPermissions', function ($state, $stateParams, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        // The access permission of 'signature capture response' page depends on 'signature capture' page:
                        return PortalPermissions.view('portal.menus.signatureCapture').then(function (access) {
                            //No access
                            if (!access) {
                                $state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
    }])
;